import { MeshReflectorMaterial } from "@react-three/drei"
import { useLoader } from "@react-three/fiber"
import { useEffect } from "react"
import { TextureLoader, RepeatWrapping, LinearEncoding } from "three"

const Floor = () =>
{
    const [ normalT, heightT, roughnessT, aoT ] = useLoader(TextureLoader, [
        '/textures/Tiles_Modern_002_normal.jpg',
        '/textures/Tiles_Modern_002_height.png',
        '/textures/Tiles_Modern_002_roughness.jpg',
        '/textures/Tiles_Modern_002_ambientOcclusion.jpg'
    ])

    // transform textures
    // useEffect(()=>{
    //     [ normalT, heightT, roughnessT, aoT ].forEach((t)=>{
    //         t.wrapS = RepeatWrapping
    //         t.wrapT = RepeatWrapping
    //         t.repeat.set(5,5)
    //     })

    //     normalT.encoding = LinearEncoding
    // }, [normalT, heightT, roughnessT, aoT])

    return(
        <>
            <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.415, 0]}>
            <circleGeometry args={[6, 32, 32]} />
            <MeshReflectorMaterial
                resolution={ 512 }
                blur={ [ 1000, 1000 ] }
                mixBlur={ 2 }
                mirror={ 1.5 }
                color="#666666" 
                // map={colorT}
                normalMap={normalT}
                roughnessMap={roughnessT}
                roughness={0.9}
                aoMap={aoT}
                aoMapIntensity={2}
                displacementMap={heightT}
                displacementScale={3}
            />    
            
            </mesh>

            <mesh rotation={[Math.PI / 2, 0, 0]} position={[0, 1.1, 0]}>
            <circleGeometry args={[6, 32, 32]} />
            <MeshReflectorMaterial
                resolution={ 512 }
                blur={ [ 1000, 1000 ] }
                mixBlur={ 2 }
                mirror={ 1.5 }
                color="#aaaaaa" 
            />    
            </mesh>
        </>
    )
}

export default Floor